import { EventPagination } from '@/module/event/domain/model/event_pagination';
import { Pagination } from '@/core/domain/model/pagination';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export type EventPaginationParams = Omit<Pagination, "search"> & {
  ownerType: string;
  ownerID: number;
  eventType?: string;
}

export interface FetchEventRepository {
    (pagination: EventPaginationParams): Promise<EventPagination>
}

const fetchEventRepository = (axios: AxiosInstance): FetchEventRepository => async (pagination: EventPaginationParams) => {
    try {
        const response: AxiosResponse = await axios.get('/event', {
            params: pagination
        })

        const result: EventPagination = response.data
        return result
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchEventRepository
